<template>
  <svg
    :class="['icon', `icon-${variation}`]"
    data-sb-regression="sb-icon"
    v-on="$attrs"
  >
    <use
      :xlink:href="`#icon-${variation}`"
    />
  </svg>
</template>

<script>

export default {
  name: 'SbIcon',
  props: {
    /**
     * Style variation to give additional meaning.
     */
    variation: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang='scss'>
	@import '@src/components/Icons/style/sb-icon.scss';
</style>
